import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom';
import {get} from 'lodash';

import './main-content.style.css';
import SideBar from '../sidebar/sidebar.components';
import WrapperSideBar from '../sidebar/wrapper-sidebar.component';

// import {withRouter} from 'react-router-dom';
import {storeListDMAForSelect} from '../../../redux/general/action';
import { getListDMA } from '../../../api/list_DMA';
import { getToken } from '../../../api/get_token';
import DashboardPage from '../../page/dashboard-page/dashboard-page.component';
import PipelineDetailPage from '../../page/pipeline-page/pipeline-page.component';
import NRWCalculatePage from '../../page/nrwmanagement-page/nrwcalculate-page.component';
import MapPage from '../../page/map-page/map-page.component';
import RealLoss from '../../page/real-loss-page/real-loss-page.component';
import WaterBalanceTable from '../../page/water-balance-table-page/water-balance-table-page.component';
import ErrorPage from '../../page/error-page.component';
import Account from '../../page/Account/index'
import routes from '../../../routes';

class MainContent extends Component {
    constructor(props){
        super();
    }

    componentDidMount = async () => {
        try {
            const resGetToken = await getToken();
            const token = resGetToken.data.token;
            const reslistDMA = await getListDMA(token, '');
            const dataListDMA = reslistDMA.data.features;
            // const dataListDMA = reslistDMA.features;
            let listDMANoAttributeKey = dataListDMA.map((element) => {
                return { value: element.attributes.DMAID, label:element.attributes.DMAID  }
            });
            this.props.storeListDMAForSelect(listDMANoAttributeKey);
            // console.log('listDMANoAttributeKey:', listDMANoAttributeKey);
        } catch (error) {
            console.log('Error in get DMA',error);
        }
    }

    render() {
        const slug = this.props.currentPath; //lay tu react router
        // console.log('slugmaincontent: ', slug);
        return (
            <div className="section-main-content">
                <div className="wrapper">
                    {/* <SideBar></SideBar> */}
                    <WrapperSideBar></WrapperSideBar>
                    <div className="main-content">
                        <Switch>
                            <Route path={routes.home} component={DashboardPage} exact/>
                            <Route path={routes.pipelinedetail} component={PipelineDetailPage} exact />
                            <Route path={routes.nrwcalculate} component={NRWCalculatePage} exact />
                            <Route path={routes.map}  component={MapPage} exact/>
                            <Route path={routes.realLoss} component={RealLoss} exact/>
                            <Route path={routes.waterBalanceTable} component={WaterBalanceTable} exact/>
                            <Route path={routes.account} component={Account} exact/>
                            <Route component={ErrorPage} />
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}

// export default MainContent;
const mapStateToProps = state => ({
    listDMAForSelect: get(state, 'GeneralStore.listDMAForSelect')
})

const mapDispatchToProps = dispatch => {
    return {
    storeListDMAForSelect: listDMAForSelect => {
        dispatch(storeListDMAForSelect(listDMAForSelect))
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(MainContent)


